import React from 'react';
import { Box, Button, makeStyles, CircularProgress } from '@material-ui/core';
import { useTranslate, useNotify } from 'react-admin';
import { ScannerConnectStatus, useScannerConnect } from './useScannerConnect';
import { ScannerStatusIndicator } from '../_shared/ScannerStatusIndicator';

const useStyles = makeStyles({
    container: {
        display: 'flex',
        alignItems: 'center',
        margin: '0 16px',
    },
});

export const SPPScannerControl = () => {
    const classes = useStyles();
    const t = useTranslate();
    const notify = useNotify();
    const {
        isConnected,
        isDeviceAuthorized,
        isReconnecting,
        connect,
        forget,
    } = useScannerConnect();

    const handleConnect = async () => {
        const result = await connect();

        if (result.status === ScannerConnectStatus.authorized) {
            notify(
                `✅ ${t('scanner.notifications.device_authorized', { _: 'Device authorized successfully' })}`,
                { type: 'success', autoHideDuration: 5000 }
            );
        } else if (result.status === ScannerConnectStatus.failed) {
            notify(`❌ ${result.message}`, { type: 'error', autoHideDuration: 5000 });
        }
    };

    // Show CONNECT button if device not authorized yet
    if (!isDeviceAuthorized) {
        return (
            <Box className={classes.container}>
                <ScannerStatusIndicator connected={false} />
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleConnect}
                >
                    {t('osfc.buttons.connect')}
                </Button>
            </Box>
        );
    }

    // Device is authorized - show status and forget button
    return (
        <Box className={classes.container}>
            <ScannerStatusIndicator connected={isConnected} />
            <Button
                variant="contained"
                onClick={forget}
                disabled={isReconnecting}
            >
                {isReconnecting ? (
                    <>
                        <CircularProgress size={16} style={{ marginRight: 8 }} />
                        {t('scanner.reconnecting', { _: 'Reconnecting...' })}
                    </>
                ) : (
                    t('scanner.forget', { _: 'Forget Device' })
                )}
            </Button>
        </Box>
    );
};
